import { render, staticRenderFns } from "./PiezasDisparo.vue?vue&type=template&id=6681b713&"
import script from "./PiezasDisparo.vue?vue&type=script&lang=js&"
export * from "./PiezasDisparo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports